import { formatClock, formatStoredDayOrClock, isCalendarDayString } from "../../helper/dateTime";

/**
 * Safe message from a Track API error body.
 *
 * @param {?{data?: *}} error
 * @return {string}
 */
export function apiError(error) {
  const data = error?.data;
  if (typeof data === "string") return "The request failed. Please try again.";
  if (data?.detail) return String(data.detail);
  if (data && typeof data === "object")
    return Object.entries(data)
      .map(
        ([field, messages]) =>
          `${field.replaceAll("_", " ")}: ${Array.isArray(messages) ? messages.join(" ") : messages}`,
      )
      .join(" ");
  return "The request failed. Please try again.";
}

/**
 * Human label for a tracking status or event code.
 *
 * @param {?string} value
 * @return {string}
 */
export function label(value) {
  return (value || "Unavailable").replaceAll("_", " ");
}

/**
 * Last provider sync clock in the company timezone.
 *
 * @param {?string} value
 * @param {string=} timeZone
 * @return {string}
 */
export function reportedTime(value, timeZone) {
  if (!value) return "No successful update yet";
  return formatClock(value, { timeZone });
}

/**
 * Track dates the same way as sales-order / purchase-order days.
 *
 * Calendar days stay on that day (no UTC midnight shift). Clocks use
 * the company timezone from dateTime.js.
 *
 * @param {?string} value
 * @param {string=} timeZone
 * @return {string}
 */
export function trackWhen(value, timeZone) {
  if (!value) return "Date unavailable";
  const text = String(value).trim();
  if (isCalendarDayString(text)) {
    return formatStoredDayOrClock(text, "MMM DD, YYYY");
  }
  return formatClock(value, { timeZone });
}

/**
 * True when value is a four-letter, seven-digit container number.
 *
 * @param {string} value
 * @return {boolean}
 */
export function validateOceanReference(value) {
  return /^[A-Z]{3}[UJZ][0-9]{7}$/.test(value.trim().toUpperCase());
}
